// ─── API URL ──────────────────────────────────────────────────────────────────
// Development : http://localhost:5001  (matches server/.env.development PORT)
// Production  : https://drivercrm-production.up.railway.app (fallback: system.topsailroofing.com)
// Override either by setting REACT_APP_API_URL in your .env file.
const apiUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://drivercrm-production.up.railway.app'
    : 'http://localhost:5001');

export const config = {
  apiUrl,
  mapboxAccessToken:
    'pk.eyJ1IjoidG9wc2FpbHJvb2ZpbmciLCJhIjoiY21ydjhpOGhsMGY5ejJ5cTNma3VzMzU5MCJ9.3jksm6bwJf7thqF22H5Vhw',
};